import CoreInputTextLeft from "./CoreInputTextLeft";
import createFabric from "../../../../../fabrics/createFabric";

export default createFabric("Left", CoreInputTextLeft);
